import Link from "next/link";
import DaoBlock from "../dao/DaoBlock";
import Image from "next/image";
import News_item from "./new_item";
import { new_data } from "../../data/news_data";
import ImpactoverseForTextAnimation from "./impactoverseForTextAnimation";
const servicesData = [
  {
    title: "Gamify impactful projects",
    description:
      "Plan it, create it, launch it. Collaborate seamlessly with all the organization and hit your marketing goals every month with our marketing plan.",
    image: "/images/wallets/Immersive.svg",
    bgColor: "bg-accent-dark",
    class: "",
  },
  {
    title: "Play to change the world",
    description:
      "Protect your organization, devices and stay compliant with our structured workflows and custom permissions made for you.",
    image: "/images/wallets/Innovation.svg",
    bgColor: "bg-accent-dark", // "bg-green",
    class: "w-[60px]",
  },
  {
    title: "Create an education experience",
    description:
      "Auto-assign tasks, send Slack messages, and much more. Now power up with hundreds of new templates to help you get started.",
    image: "/images/wallets/AI.svg",
    bgColor: "bg-accent-dark", //"bg-orange",
    class: "w-[67px]", //     width: 67px;
  },
  {
    title: "Launch or support a campaign",
    description:
      "Audit-proof software built for critical financial operations like month-end close and quarterly budgeting.",
    image: "/images/wallets/Impact.svg",
    bgColor: "bg-accent-dark", //"bg-blue",
    class: "",
  },
  {
    title: "Align with a cause",
    description:
      "Craft beautiful, delightful experiences for both marketing and product with real cross-company collaboration.",
    image: "/images/wallets/Recognition.svg",
    bgColor: "bg-accent-dark",
    class: "w-[52px]",
  },
  {
    title: "Buy or sell for impact",
    description:
      "Keep your company’s lights on with customizable, iterative, and structured workflows built for all efficient teams and individual.",
    image: "/images/wallets/Digital.svg",
    bgColor: "bg-accent-dark", //"bg-green",
    class: "w-[52px]",
  },
];
const homeSection3 = () => {
  return (
    <section className="relative py-24 pb-10">
      <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
        <Image
          width={1519}
          height={935}
          src="/images/gradient.jpg"
          alt="gradient"
          className="h-full w-full object-cover"
        />
      </picture>
      <picture className="pointer-events-none absolute inset-0 -z-10 hidden dark:block !ml-0">
        <Image
          width={1519}
          height={935}
          src="/images/gradient_dark.jpg"
          alt="gradient dark"
          className="h-full w-full object-cover"
        />
      </picture>

      <div className="container">
        <div className="mx-auto mb-12 text-center">
          <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase">
            MAKE A <span className="animate-gradient"> DIFFERENCE </span>
          </h1>
          <p className="text-lg dark:text-jacarta-300">
            Step into our WORLD OF IMPACT or collaborate on, support or launch
            an IMPACT ART campaign. Leverage our platform to keep ahead of the
            curve with impact engagement and actions that save the world!
            {/* Align with impact initiatives in our IMPACT DOT campaigns or step into our WORLD OF IMPACT and motivate and inspire by showcasing your impact. Leverage our platform to keep ahead of the curve with engagement, (affordably!), so you can focus on your core activities and impact.  */}
          </p>
        </div>

        {/* Start global distribute and dao idea */}
        <div className="lg:flex lg:space-x-12">
          <div className="mb-12 lg:w-1/2">
            {/* <div className="rounded-2.5xl bg-white p-12 dark:bg-jacarta-700">
              <span className="mb-2 mt-1 block font-display text-xl font-medium group-hover:text-accent dark:text-white transition transition-colors">
                KICKSTART A CAMPAIGN
              </span>
              <p className="mb-8 text-lg dark:text-jacarta-300">
              Launch an Impact DOT Campaign to earn while you also grow and empower your community of supporters. It’s win-win-win!
              </p>
              <Link
                href="https://artforimpact.club"
                target="_blank" 
                className="inline-block rounded-full bg-accent py-3 px-8 text-center font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark"
              >
                FIND OUT MORE
              </Link>
            </div> */}

            <div className="rounded-2.5xl bg-white p-12 dark:bg-jacarta-700">
              <span className="mb-2 mt-1 block font-display text-xl font-medium group-hover:text-accent dark:text-white transition transition-colors">
                WORLD OF IMPACT
              </span>
              <p className="mb-8 text-lg dark:text-jacarta-300">
                Dive into a world of amazing experiences, games, innovations and
                opportunities for impact that rewards you!
              </p>
              <a
                href="/our-world-of-impact"
                target="_blank"
                className="inline-block rounded-full bg-accent py-3 px-8 text-center font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark"
              >
                FIND OUT MORE
              </a>
            </div>
          </div>
          <div className="mb-12 lg:w-1/2">
            <div className="h-full rounded-2.5xl bg-white p-12 dark:bg-jacarta-700">
              <span className="mb-2 mt-1 block font-display text-xl font-medium group-hover:text-accent dark:text-white  transition-colors">
                IMPACT ART CAMPAIGNS
                {/* SHOWCASE MY IMPACT  */}
              </span>
              <p className="mb-8 text-lg dark:text-jacarta-300">
                Showcase your impact and inspire others by sharing your journey,
                achievements, and the positive changes you’ve made.
              </p>
              <Link
                href="/art-for-impact-campaign"
                className="inline-block rounded-full bg-accent py-3 px-8 text-center font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark"
              >
                FIND OUT MORE
              </Link>
            </div>
          </div>
        </div>
        {/* End global distribute and dao idea */}
        {/* Start global distribute and dao idea */}
        <div className="lg:flex lg:space-x-12">
          <div className="mb-12 lg:w-full">
            <div className="h-full rounded-2.5xl bg-white p-12 dark:bg-jacarta-700 border-jacarta-100 rounded-full max-sm:rounded-[100px] border">
              <div className="flex flex-col items-center">
                <span className="mb-2 mt-1 block font-display text-xl font-medium group-hover:text-accent dark:text-white ">
                  DONE FOR YOU SERVICE
                </span>
                <p className="mb-8 mx-auto max-w-2xl text-center text-lg dark:text-jacarta-300">
                  Would you rather have it all done for you? Get in touch, and
                  if it’s the right option for you, we’ll take care of it all!
                </p>
                <Link
                  href="/contact-us"
                  className="inline-block rounded-full bg-accent py-3 px-8 text-center font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark uppercase"
                >
                  GET IN TOUCH
                </Link>
              </div>

              {/* <p className="mb-8 text-lg dark:text-jacarta-300">
              Would you rather have it all done for you? Get in touch, and if it’s the right option for you, we’ll take care of it all!

              </p>
              <Link
                href="/contact-us"
                target="_blank"
                className="flex  rounded-full bg-accent py-3 px-8 text-center font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark"
              >
                GET IN TOUCH
              </Link> */}
            </div>
          </div>
        </div>

        {/* End global distribute and dao idea */}

        {/* start call to action weekly digest */}
        {/* <div className="rounded-2.5xl bg-white px-12 py-20 text-center dark:bg-jacarta-700">
          <HeadLine
            text=" Weekly Digest"
            classes="mb-5 font-display text-3xl text-jacarta-700 dark:text-white"
          />

          <p className="mx-auto max-w-2xl text-center text-lg text-jacarta-700 dark:text-white">
            Join our mailing list to stay in the loop with our newest feature
            releases, Impact DOT drops, and tips and tricks for navigating
            Impactoverse
          </p>

          <div className="mx-auto mt-7 max-w-md text-center">
            <form className="relative" onSubmit={(e) => e.preventDefault()}>
              <input
                type="email"
                placeholder="Email address"
                className="dark:bg-jacarta-700 dark:border-jacarta-600 focus:ring-accent border-jacarta-100 w-full rounded-full border py-3 px-4 dark:text-white dark:placeholder-white"
              />
              <button className="hover:bg-accent-dark font-display bg-accent absolute top-2 right-2 rounded-full px-6 py-2 text-sm text-white">
                Subscribe
              </button>
            </form>
          </div>
        </div> */}
        {/* end call to action weekly digest */}
      </div>
      <ImpactoverseForTextAnimation />
      <div className="pt-24">
        <section className="bg-jacarta dark:text-white py-16 px-4">
          <div className="max-w-7xl mx-auto text-center">
            <h1 className="font-display mb-10 text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center">
              WHAT&#39;S <span className="animate-gradient"> NEW</span>
            </h1>
            <div className="grid md:grid-cols-3 gap-8">
              {new_data.map((card, index) => (
                <div
                  key={index}
                  className="dark:bg-[#1E1F3A] rounded-xl shadow-lg overflow-hidden p-6 flex flex-col items-center justify-between hover:bg-transparent hover:bg-accent-light hover:border hover:border-accent"
                >
                  <Image
                    src={card.image}
                    alt={card.title}
                    width={500}
                    height={700}
                    className="w-full  object-cover rounded-md mb-6"
                  />
                  <h3 className="text-xl font-bold mb-3 dark:text-white">
                    {card.title}
                  </h3>
                  <p className="dark:text-gray-300 text-sm text-start mb-6">
                    {card.description}
                  </p>

                  <Link
                    className="uppercase bg-accent shadow-accent-volume hover:bg-accent-light hover:bg-accent-dark inline-block rounded-full py-3 px-8 text-center font-semibold text-white transition-all"
                    href={card.url}
                  >
                    READ MORE
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
      <section className="py-12 px-6">
        <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase mb-8">
          GET <span className="animate-gradient"> INVOLVED</span>
          {/* MAKE A <span className="animate-gradient"> DIFFERENCE</span> */}
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {servicesData.map((service, index) => (
            // <div
            //   key={index}
            //   className="rounded-2.5xl shadow-md p-6 bg-white dark:bg-jacarta-700"
            // >
            //   <div className="flex justify-center items-center mb-4 w-12 h-12 rounded-full bg-primary-100 ml-2 lg:h-16 lg:w-16 dark:bg-primary-900">
            //     <div className="rounded-xl text-center flex-1 m-4">

            //       <div className="flex items-center justify-center">
            //         <div
            //           className={`rounded-full w-20 h-20 m-4 flex items-center justify-center ${service.bgColor}`}
            //         >
            //           <Image
            //             width={86}
            //             height={86}
            //             src={service.image}
            //             className={`,-4 ${service.class}`}
            //             alt="wallet"
            //           />
            //         </div>
            //       </div>
            //     </div>
            //   </div>
            //   <h3 className="mb-2 text-xl font-bold dark:text-white">
            //     {service.title}
            //   </h3>
            // </div>

            <div
              key={index}
              className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 rounded-2.5xl mb-8 border bg-white p-8 text-center transition-shadow hover:shadow-lg"
            >
              {/* className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 rounded-2.5xl mb-8 border bg-white p-8 text-center transition-shadow hover:shadow-lg" */}
              {/* <Image
                width={86}
                height={86}
                src={image}
                className="dark:border-jacarta-600 dark:bg-jacarta-700 border-jacarta-100 mx-auto mb-7 -mt-[3.5rem] h-[5.5rem] w-[5.5rem] rounded-full border bg-white"
                alt="wallet"
              /> */}
              <div className="flex items-center justify-center">
                <div
                  className={`rounded-full w-20 h-20 m-4 flex items-center justify-center ${service.bgColor}`}
                >
                  <Image
                    width={86}
                    height={86}
                    src={service.image}
                    className={`,-4 ${service.class}`}
                    alt="wallet"
                  />
                </div>
              </div>
              <h3 className="mb-2 mt-1 block font-display text-xl font-medium group-hover:text-accent dark:text-white uppercase">
                {service.title}
              </h3>
            </div>
          ))}
        </div>
      </section>
    </section>
  );
};

export default homeSection3;
